import { Hash } from 'lucide-react';
import clsx from 'clsx';
import type { InternalCommsChannel } from '@/domain/types';
import { unreadInContainer } from '@/utils/commsHelpers';

interface Props {
  channels: InternalCommsChannel[];
  activeId: string | null;
  onPick: (id: string) => void;
  lastReadByChannel: Record<string, string>;
  selfPersonId: string | null;
}

export default function ChannelList({
  channels,
  activeId,
  onPick,
  lastReadByChannel,
  selfPersonId,
}: Props) {
  return (
    <ul className="space-y-0.5" data-testid="comms-channel-list">
      {channels.map((c) => {
        const unread = unreadInContainer(c, lastReadByChannel[c.id], selfPersonId);
        const active = c.id === activeId;
        return (
          <li key={c.id}>
            <button
              type="button"
              onClick={() => onPick(c.id)}
              data-testid={`comms-channel-${c.id}`}
              className={clsx(
                'w-full flex items-center gap-2 px-3 py-1.5 text-left text-sm transition rounded-md',
                active
                  ? 'bg-gold/15 text-cream border-l-2 border-gold-bright'
                  : 'text-cream-soft hover:bg-ink-soft/50',
              )}
            >
              <Hash size={11} className={active ? 'text-gold-bright' : 'text-cream-faint'} />
              <span className="flex-1 truncate font-inter">
                {c.name.replace(/^#\s*/, '')}
              </span>
              {unread > 0 ? (
                <span
                  className="px-1.5 rounded-full bg-blood text-white text-[10px] font-mono font-bold min-w-[18px] text-center"
                  data-testid={`comms-unread-${c.id}`}
                >
                  {unread > 9 ? '9+' : unread}
                </span>
              ) : null}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
